"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireDefault(require("react"));
var _SVBButton = require("../../SVBButton");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 * Global components
 * By Bhargav Shivaprasad <bshivaprasad@svb.com> (www.svb.com)
 * Summary
 * This component renders an SVB Hero Section
 */

/**
 * SVB Hero Section
 * @param title: Main title for hero section
 * @param description: Description for the hero section
 * @param headerTitle: secondary title above main title
 * @param rightImage: Secondary image for hero section
 * @param buttonTitle: title for the button
 * @param handleButtonPress: function for handling on button press
 */
function SVBHeroSection(props) {
  var _props$title, _props$description, _props$headerTitle, _props$rightImage, _props$buttonTitle;
  const title = (_props$title = props === null || props === void 0 ? void 0 : props.title) !== null && _props$title !== void 0 ? _props$title : "";
  const description = (_props$description = props === null || props === void 0 ? void 0 : props.description) !== null && _props$description !== void 0 ? _props$description : "";
  const headerTitle = (_props$headerTitle = props === null || props === void 0 ? void 0 : props.headerTitle) !== null && _props$headerTitle !== void 0 ? _props$headerTitle : "";
  const rightImage = (_props$rightImage = props === null || props === void 0 ? void 0 : props.rightImage) !== null && _props$rightImage !== void 0 ? _props$rightImage : "";
  const buttonTitle = (_props$buttonTitle = props === null || props === void 0 ? void 0 : props.buttonTitle) !== null && _props$buttonTitle !== void 0 ? _props$buttonTitle : "Discover APIs";
  const handleButtonPress = props === null || props === void 0 ? void 0 : props.handleButtonPress;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "hero-section-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "container-fluid pt-4 pb-7"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex justify-self-center row"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm"
  }, /*#__PURE__*/_react.default.createElement("h2", {
    className: "p-0 hero-section-headerTitle heading-xxlarge"
  }, headerTitle), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex align-self-center text-align-center mt-3 hero-section-headerTitle-underline"
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "row d-flex pt-3"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm-3 align-content-center hero-section-font-white hero-section-fixed-container"
  }, /*#__PURE__*/_react.default.createElement("h1", {
    className: "hero-section-font-white heading-xxxlarge"
  }, title), /*#__PURE__*/_react.default.createElement("p", {
    className: "hero-section-font-white heading-medium mr-5 fw-normal font-family-roboto"
  }, description), /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_SVBButton.SVBButton, {
    rightIconExtraClasses: "exploreApi-button-icon",
    extraClasses: "hero-section-button border-0",
    text: buttonTitle,
    size: "large",
    style: "primary",
    state: "default",
    type: "text",
    icon: "down",
    iconSide: "right",
    onClick: handleButtonPress
  }))), /*#__PURE__*/_react.default.createElement("div", {
    className: "col-sm d-flex justify-content-center hero-section-font-white"
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: rightImage
  })))));
}
var _default = SVBHeroSection;
exports.default = _default;